import React from 'react'
import HeroSection from './components/HeroSection'
import SubscriptionMenu from './components/SubscriptionMenu'
import SubscriptionPlans from './components/SubscriptionPlans'
import SubscriptionForm from './components/SubscriptionForm'

export default function NewSubs() {
  return (
    <div>
        <HeroSection/>
        <SubscriptionMenu/>
        <SubscriptionPlans/>
        <SubscriptionForm/>
    </div>
  )
}